"use strict";
exports.__esModule = true;
exports.Synonym = void 0;
/**
 * Result class
 */
var Synonym = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param words
     */
    function Synonym(words) {
        this.words = words;
    }
    /**
     * get words
     *
     * @return {string[]}
     */
    Synonym.prototype.getWords = function () {
        return this.words;
    };
    /**
     * Create by words
     *
     * @param words
     *
     * @return {Synonym}
     */
    Synonym.createbyWords = function (words) {
        return new Synonym(words);
    };
    /**
     * To array
     *
     * @return {{words: string[]}}
     */
    Synonym.prototype.toArray = function () {
        return {
            words: this.words,
        };
    };
    /**
     * create from array
     *
     * @param array
     *
     * @returns {Synonym}
     */
    Synonym.createFromArray = function (array) {
        return new Synonym(array.words instanceof Object
            ? array.words
            : []);
    };
    /**
     * Expand
     *
     * @returns {string}
     */
    Synonym.prototype.expand = function () {
        return this.words.join(",");
    };
    return Synonym;
}());
exports.Synonym = Synonym;
